module.exports = __webpack_public_path__ + "img/yinshipin.05968cd7.png";